import '@pwlaunch/pwa-sdk/sw/loader';

import ReactDOM from 'react-dom/client'

import { hasConfig, setConfig } from '@pwlaunch/pwa-sdk/config';
import { logEvent } from '../../../packages/pwa-sdk/src/utils/logger';
import { MainProvider } from '@pwlaunch/pwa-sdk';
import { InstallerApp } from './playMarket';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

setConfig(window.__appConfig);

if(!hasConfig()) {
	logEvent('Приложение запущено без конфигурации');
} else {
	logEvent('start in install mode');
	ReactDOM.hydrateRoot(rootElement, <MainProvider><InstallerApp /></MainProvider>)
}
